import Header from "../components/Header/Header";
import { Outlet } from "react-router";
import BgImage from '../assets/images/tmo-bg.jpg';

const PrivateLayout = () => (
    <>
      <div className='h-[100vh] overflow-y-hidden'>
        <Header />
        <main className="h-full bg-no-repeat bg-center bg-cover" style={{ backgroundImage: `url(${BgImage})`}}>
          <div className="mx-auto max-w-7xl py-2 px-2 2xl:px-0">
            <div className="py-4">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </>
);

export default PrivateLayout;
